module.exports = __webpack_public_path__ + "static/media/AppStructure.63706d2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/AppStructure.png
// module id = 1108
// module chunks = 2